export const FILTER_LOCALES = 'localeIds';
export const FILTER_CONVERSION_PAGE_IDS = 'conversionPageIds';
export const CAMPAIGN_IDS = 'campaignIds';

export const FILTER_DEPENDENCIES = {
  [FILTER_CONVERSION_PAGE_IDS]: [FILTER_LOCALES],
};
